import { Chip, Stack, Typography } from '@mui/material'

import { PreSaleStatus } from '@/clients/utoniq-core/schema'
import { PreSaleStatusTag } from '@/components/organisms'
import { State } from '@/components/pages/LotteryDetail/template'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { filterHiddenItem } from '@/lib/array'

type LotteryContentCellProps = {
  preSale: State['preSale']
}
export const LotteryContentCell: Cell<LotteryContentCellProps> = ({
  preSale,
}) => {
  const { t } = useTranslation('lotteryDetail')

  const ticketInfos = filterHiddenItem([
    {
      title: t('applicationDate', '受付期間'),
      content: `${preSale?.lottery?.formattedApplicationStartedAt} 〜 ${preSale?.lottery?.formattedApplicationEndedAt}`,
    },
    {
      title: t('resultNoticeDate', '結果発表予定日'),
      content: preSale?.lottery?.formattedResultNoticedAt ?? '',
      hidden: !preSale?.lottery?.resultNoticedAt,
    },
    {
      title: t('purchasableDate', '購入期間'),
      content: `${preSale?.lottery?.formattedPurchasableStartedAt} 〜 ${preSale?.lottery?.formattedPurchasableEndedAt}`,
      hidden: preSale?.preSaleStatus === PreSaleStatus.BeforeReceiption,
    },
  ])

  return (
    <CellFrame sx={{ pb: 5 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ py: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ flex: 1, minWidth: 'fit-content' }}
        >
          <Chip
            variant="outlined"
            label={
              <Typography variant="overline">{t('lottery', '抽選')}</Typography>
            }
            sx={{
              bgcolor: 'background.default',
              p: 0,
              height: 20,
              '.MuiChip-label': { p: 1 },
            }}
          />
          {!!preSale?.lottery?.applicationEndedAt && (
            <PreSaleStatusTag status={preSale?.preSaleStatus} />
          )}
        </Stack>
        <Typography width="100%" variant="subtitle1">
          {preSale?.event?.title}
        </Typography>
      </Stack>
      <Typography variant="body2">{preSale?.description}</Typography>
      {ticketInfos.map((info, index) => (
        <Stack sx={{ py: 2 }} key={index} spacing={1}>
          <Typography variant="subtitle1" color="text.secondary">
            {info.title}
          </Typography>
          <Typography variant="body2">{info.content}</Typography>
        </Stack>
      ))}
    </CellFrame>
  )
}
